module.exports = __webpack_public_path__ + "fonts/Lato-Regular.19df47b.eot";